import * as React from 'react';
import { OpgaveDelopgaver } from '../../models/OpgaveDelopgaver';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { RouteComponentProps } from 'react-router';
import OpgaveBedoemmelsePresenter from './OpgaveBedoemmelsePresenter';
import { Spinner } from '../../uiComponents/Spinner';
import { Konkurrence } from '../../models/Konkurrence';
import { BedoemmelseTabel } from '../../models/BedoemmelseTabel';
import { ForsoegAdd } from '../../models/ForsoegAdd';
import { DelopgaveListItem } from '../../models/DelopgaveListItem';
import { ResultatAngivesIEnum } from '../../models/enums/ResultatAngivesIEnum';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import { MultipleChoiceBesvarelse } from '../../models/MultipleChoiceBesvarelse';
import { MultipleChoiceSvarSave } from '../../models/MultipleChoiceSvarSave';
import { MultipleChoiceAfslut } from '../../models/MultipleChoiceAfslut';
import NotificationData from '../../uiComponents/layout/NotificationData';
import NotificationQueue from '../../uiComponents/layout/NotificationQueue';
import { ValidationError, ValidationResult } from '../../infrastructure/ValidationResult';
import { getHoldListFromCache } from '../../infrastructure/HoldListCache';
import { Hold } from '../../models/Hold';
import { Redirect } from 'react-router-dom';
import { KonkurrenceDelopgaveAfslutningstidspunkt } from '../../models/KonkurrenceDelopgaveAfslutningstidspunkt';
import { Forsoeg } from '../../models/Forsoeg';

export interface OpgaveBedoemmelseContainerProps extends RouteComponentProps<any> {
}

class OpgaveBedoemmelseContainerState {
    opgaver?: OpgaveDelopgaver[];
    konkurrence?: Konkurrence;
    valgtDelopgaveId?: string;
    valgtOpgaveId?: string;
    bedoemmelser?: BedoemmelseTabel;
    multipleChoiceBesvarelse?: MultipleChoiceBesvarelse;
    isSaving: boolean;
    validationError?: ValidationError;
    holdList?: Hold[];
    holdListTilIndtastning?: Hold[];
    valgtHold?: Hold;
    besvarelseIndsendt: boolean;
    initLoad: boolean;
    validationResultStartDelopgave?: ValidationResult;
    samletResultat: string;
    indtastedeValues: string[];
}

class OpgaveBedoemmelseContainer extends React.Component<OpgaveBedoemmelseContainerProps, OpgaveBedoemmelseContainerState> {
    constructor(props: OpgaveBedoemmelseContainerProps) {
        super(props);

        let state = new OpgaveBedoemmelseContainerState();
        state.valgtDelopgaveId = undefined;
        state.valgtOpgaveId = undefined;
        state.isSaving = false;
        state.besvarelseIndsendt = false;
        state.validationResultStartDelopgave = new ValidationResult();
        state.samletResultat = '';
        state.indtastedeValues = new Array();

        this.state = state;

        this.onOpgaveChanged = this.onOpgaveChanged.bind(this);
        this.onDelopgaveChanged = this.onDelopgaveChanged.bind(this);
        this.onForsoegAdded = this.onForsoegAdded.bind(this);
        this.onForsoegDeleted = this.onForsoegDeleted.bind(this);
        this.getKonkurrenceId = this.getKonkurrenceId.bind(this);
        this.getDelopgaveId = this.getDelopgaveId.bind(this);
        this.getValgtDelopgave = this.getValgtDelopgave.bind(this);
        this.getHoldId = this.getHoldId.bind(this);
        this.onMultipleChoiceSvarChanged = this.onMultipleChoiceSvarChanged.bind(this);
        this.onIndsendBesvarelse = this.onIndsendBesvarelse.bind(this);
        this.onHoldChanged = this.onHoldChanged.bind(this);
        this.onStartDelopgave = this.onStartDelopgave.bind(this);
        this.onIndtastetValueChanged = this.onIndtastetValueChanged.bind(this);
        this.onSamletResultatSubmittet = this.onSamletResultatSubmittet.bind(this);
        this.onSamletResultatValueChanged = this.onSamletResultatValueChanged.bind(this);
    }

    componentDidMount() {
        var id = this.props.match.params.id;

        let self = this;
        let apiCaller = createApiCaller();
        apiCaller.getOpgaverForKonkurrence(id).then(response => {
            self.setState({ opgaver: response });
        });

        apiCaller.getKonkurrence(id).then(response => {
            self.setState({ konkurrence: response });
        });
    }

    componentDidUpdate() {
        var opgaveIdGetParam = this.props.match.params.opgaveId;
        var delopgaveIdGetParam = this.props.match.params.delopgaveId;

        if (this.state.opgaver !== undefined && this.state.opgaver.length > 0 && !this.state.initLoad) {
            if (this.state.valgtOpgaveId === undefined && this.state.valgtDelopgaveId === undefined) {
                if (opgaveIdGetParam !== undefined && opgaveIdGetParam.length > 0) {
                    this.setState({ valgtOpgaveId: opgaveIdGetParam });
                }
            }

            if (this.state.valgtOpgaveId !== undefined && this.state.valgtDelopgaveId === undefined && delopgaveIdGetParam !== undefined) {
                this.setState({ initLoad: true });
                this.onDelopgaveChanged(delopgaveIdGetParam);
            }
        }
    }

    onIndtastetValueChanged(value: string, index: number) {
        var tempValues = this.state.indtastedeValues;
        tempValues[index] = value;
        var tempTotal = 0;
        tempValues.forEach(v => {
            const val = v.replace(',', '.');
            if (!isNaN(+val) && val) {
                tempTotal += parseFloat(val);                
            }
        });

        const total = tempTotal % 1 === 0 ? tempTotal.toString() : tempTotal.toFixed(2);

        this.setState({ samletResultat: total.replace('.', ','), indtastedeValues: tempValues });
    }

    onSamletResultatValueChanged(value: string) {
        const delopgave = this.getValgtDelopgave(this.state.valgtDelopgaveId);

        if (delopgave && delopgave.delopgaveBedoemmelsesFaktorer.length === 0) {
            this.setState({ samletResultat: value });
        }

    }

    onSamletResultatSubmittet(holdId: string) {
        const delopgave = this.getValgtDelopgave(this.state.valgtDelopgaveId);
        this.onForsoegAdded(holdId, this.state.samletResultat);

        const arrayLength = delopgave ? delopgave.delopgaveBedoemmelsesFaktorer.length : 0;
        var emptyArray = new Array(arrayLength).fill('');
        this.setState({ samletResultat: '', indtastedeValues: emptyArray });
    }

    onForsoegAdded(holdId: string, value: string): Promise<boolean> {
        const caller = createApiCaller();

        const forsoegAdd = new ForsoegAdd();
        forsoegAdd.konkurrenceId = this.getKonkurrenceId();
        forsoegAdd.delopgaveId = this.getDelopgaveId();
        forsoegAdd.holdId = holdId;
        forsoegAdd.value = value;

        const backupBedoemmelseTabel = this.state.bedoemmelser;
        const tempBedoemmelseTabel = this.state.bedoemmelser;

        if (tempBedoemmelseTabel) {
            tempBedoemmelseTabel.bedoemmelser.forEach(bedoemmelse => {
                if (bedoemmelse.holdId === holdId) {
                    const forsoeg = new Forsoeg();
                    forsoeg.value = value;
                    bedoemmelse.forsoeg.push(forsoeg);
                }
            });
        }

        this.setState({ bedoemmelser: tempBedoemmelseTabel });

        let self = this;
        const promise = caller.addForsoeg(forsoegAdd).then(addForsoegResponse => {
            let validationError: ValidationError | undefined = undefined;
            if (!addForsoegResponse.isValid) {
                validationError = addForsoegResponse.errorMessages[0];
                validationError.field = holdId;
                self.setState({ bedoemmelser: backupBedoemmelseTabel });
            }
            caller.getBedoemmelser(forsoegAdd.konkurrenceId, forsoegAdd.delopgaveId, this.getOpgaveId()).then(getBedoemmelserResponse => {
                self.setState({ bedoemmelser: getBedoemmelserResponse, validationError: validationError });
            });

            return validationError !== undefined;
        });

        return promise;
    }

    onForsoegDeleted(forsoegId: string) {
        const caller = createApiCaller();
        let self = this;
        caller.deleteForsoeg(forsoegId).then(response =>
            caller.getBedoemmelser(self.getKonkurrenceId(), self.getDelopgaveId(), self.getOpgaveId()).then(getBedoemmelserResponse =>
                self.setState({ bedoemmelser: getBedoemmelserResponse })
            )
        );
    }

    onOpgaveChanged(opgaveId: string) {
        this.setState({ valgtOpgaveId: opgaveId, valgtDelopgaveId: undefined, valgtHold: undefined });
    }

    onDelopgaveChanged(delopgaveId: string) {
        if (this.state.valgtOpgaveId === undefined) {
            return;
        }

        let opgaveId = this.state.valgtOpgaveId !== undefined ? this.state.valgtOpgaveId : '';
        let self = this;
        let apiCaller = createApiCaller();
        var konkurrenceId = this.props.match.params.id;

        const valgtDelopgave = this.getValgtDelopgave(delopgaveId);
        if (valgtDelopgave === undefined) {
            return;
        }

        this.setState({ valgtDelopgaveId: delopgaveId, valgtHold: undefined });
        const brugerrolle = getLoggedInBruger().rolle;

        if (valgtDelopgave.resultatetAngivesI === ResultatAngivesIEnum.MultipleChoice) {
            if (brugerrolle === BrugerRolleEnum.Elev) {
                apiCaller.getMultipleChoiceBesvarelser(konkurrenceId, delopgaveId, this.getHoldId()).then(response =>
                    self.setState({ multipleChoiceBesvarelse: response })
                );
            } else {
                const tomBesvarelse = new MultipleChoiceBesvarelse();
                tomBesvarelse.spoergsmaalList = [];
                tomBesvarelse.svarList = [];
                self.setState({ multipleChoiceBesvarelse: tomBesvarelse });
            }

        } else {
            apiCaller.getBedoemmelser(konkurrenceId, delopgaveId, opgaveId).then(response =>
                self.setState({ bedoemmelser: response })
            );
        }

        this.setState({ holdList: undefined, holdListTilIndtastning: undefined });
        if (brugerrolle === BrugerRolleEnum.Administrator || brugerrolle === BrugerRolleEnum.Laerer || brugerrolle === BrugerRolleEnum.Ekstern) {
            apiCaller.GetHoldByKonkurrenceAndOpgave(konkurrenceId, opgaveId, false).then(response => self.setState({ holdList: response }));
            apiCaller.GetHoldByKonkurrenceAndOpgave(konkurrenceId, opgaveId, true).then(response => self.setState({ holdListTilIndtastning: response }));
        }
    }

    onHoldChanged(holdId: string) {
        if (this.state.holdListTilIndtastning !== undefined) {
            const hold = this.state.holdListTilIndtastning.filter(h => h.id === holdId)[0];
            this.setState({ valgtHold: hold });
            const apiCaller = createApiCaller();
            var konkurrenceId = this.props.match.params.id;

            const delopgaveId = this.state.valgtDelopgaveId;
            if (delopgaveId === undefined) {
                return;
            }
            apiCaller.getMultipleChoiceBesvarelser(konkurrenceId, delopgaveId, holdId).then(multipleChoiceBesvarelseResponse =>
                this.setState({ multipleChoiceBesvarelse: multipleChoiceBesvarelseResponse, isSaving: false })
            );
        }
    }

    getValgtDelopgave(delopgaveId?: string): DelopgaveListItem | undefined {
        if (this.state.opgaver === undefined) {
            throw Error();
        }

        if (delopgaveId === undefined || this.state.valgtOpgaveId === undefined) {
            return undefined;
        }
        const valgtOpgave = this.state.opgaver.filter(o => o.id === this.state.valgtOpgaveId)[0];
        const valgtDelopgave = valgtOpgave.delopgaver.filter(d => d.id === delopgaveId)[0];
        return valgtDelopgave;
    }

    getHoldId(): string {
        const bruger = getLoggedInBruger();
        if (bruger.rolle === BrugerRolleEnum.Elev) {
            const holdList = getHoldListFromCache();
            return holdList.filter(h => h.gruppeId === bruger.gruppeId)[0].id;
        } else {
            if (this.state.valgtHold === undefined) {
                return '00000000-0000-0000-0000-000000000000';
            }
            return this.state.valgtHold.id;
        }
    }

    onMultipleChoiceSvarChanged(spoergsmaalId: string, svarmulighedId: string) {
        const multipleChoiceBesvarelse = this.state.multipleChoiceBesvarelse;
        if (multipleChoiceBesvarelse === undefined) {
            return;
        }
        let svar = multipleChoiceBesvarelse.svarList.filter(s => s.spoergsmaalId === spoergsmaalId)[0];

        const svarSaveModel = new MultipleChoiceSvarSave();
        var konkurrenceId = this.props.match.params.id;

        const delopgaveId = this.state.valgtDelopgaveId;
        if (delopgaveId === undefined) {
            return;
        }

        const holdId = this.getHoldId();
        svarSaveModel.konkurrenceId = konkurrenceId;
        svarSaveModel.delopgaveId = delopgaveId;
        svarSaveModel.holdId = holdId;
        svarSaveModel.multipleChoiceSvarmulighedId = svarmulighedId;
        svarSaveModel.multipleChoiceSpoergsmaalId = spoergsmaalId;
        const apiCaller = createApiCaller();
        if (svar === undefined) {
            apiCaller.addMultipleChoiceSvar(svarSaveModel).then(response => {
                apiCaller.getMultipleChoiceBesvarelser(konkurrenceId, delopgaveId, holdId).then(multipleChoiceBesvarelseResponse => {
                    this.setState({ multipleChoiceBesvarelse: multipleChoiceBesvarelseResponse, isSaving: false });
                });
            });
        } else {
            svarSaveModel.id = svar.id;
            apiCaller.updateMultipleChoiceSvar(svarSaveModel).then(response => {
                apiCaller.getMultipleChoiceBesvarelser(konkurrenceId, delopgaveId, holdId).then(multipleChoiceBesvarelseResponse => {
                    this.setState({ multipleChoiceBesvarelse: multipleChoiceBesvarelseResponse, isSaving: false });
                });
            });
        }

        this.setState({ isSaving: true });
    }

    onIndsendBesvarelse() {
        const apiCaller = createApiCaller();

        const afslutModel = new MultipleChoiceAfslut();
        var konkurrenceId = this.props.match.params.id;

        const delopgaveId = this.state.valgtDelopgaveId;
        if (delopgaveId === undefined) {
            return;
        }
        afslutModel.konkurrenceId = konkurrenceId;
        afslutModel.delopgaveId = delopgaveId;
        afslutModel.holdId = this.getHoldId();

        const self = this;
        this.setState({ isSaving: true });
        apiCaller.afslutMultipleChoice(afslutModel).then(() => {
            NotificationQueue.push(new NotificationData('Besvarelse er indsendt', '', 'success'));
            self.setState({ isSaving: false, besvarelseIndsendt: true });
        });
    }

    onStartDelopgave(varighed: number) {
        const delopgaveId = this.state.valgtDelopgaveId;
        const konkurrenceId = this.props.match.params.id;
        if (delopgaveId === undefined || konkurrenceId === undefined) {
            return;
        }

        const apiCaller = createApiCaller();
        const startDelopgaveModel = new KonkurrenceDelopgaveAfslutningstidspunkt();
        startDelopgaveModel.konkurrenceId = konkurrenceId;
        startDelopgaveModel.delopgaveId = delopgaveId;
        startDelopgaveModel.varighed = varighed;

        apiCaller.setDelopgaveAfslutningstidspunkt(startDelopgaveModel).then((afslutningResponse) => {
            this.setState({
                validationResultStartDelopgave: afslutningResponse
            });
        });
    }

    render() {
        if (this.state.opgaver === undefined || this.state.konkurrence === undefined) {
            return <Spinner />;
        }
        if (this.state.besvarelseIndsendt) {
            return <Redirect to='/' />;
        }

        return (
            <OpgaveBedoemmelsePresenter
                opgaver={this.state.opgaver}
                konkurrence={this.state.konkurrence}
                valgtDelopgave={this.getValgtDelopgave(this.state.valgtDelopgaveId)}
                valgtOpgaveId={this.state.valgtOpgaveId}
                onDelopgaveChanged={this.onDelopgaveChanged}
                onOpgaveChanged={this.onOpgaveChanged}
                bedoemmelserTable={this.state.bedoemmelser}
                onForsoegAdded={this.onForsoegAdded}
                onForsoegDeleted={this.onForsoegDeleted}
                multipleChoiceBesvarelse={this.state.multipleChoiceBesvarelse}
                onMultipleChoiceSvar={this.onMultipleChoiceSvarChanged}
                onIndsendBesvarelse={this.onIndsendBesvarelse}
                isSaving={this.state.isSaving}
                validationError={this.state.validationError}
                holdList={this.state.holdList}
                holdListIndtastning={this.state.holdListTilIndtastning}
                onHoldChanged={this.onHoldChanged}
                valgtHold={this.state.valgtHold}
                onStartDelopgave={this.onStartDelopgave}
                startDelopgaveErrorMessages={this.state.validationResultStartDelopgave ? this.state.validationResultStartDelopgave.errorMessages : []}
                samletResultat={this.state.samletResultat}
                indtastedeValues={this.state.indtastedeValues}
                onIndtastetValueChanged={this.onIndtastetValueChanged}
                onSamletResultatValueChanged={this.onSamletResultatValueChanged}
                onSamletResultatSubmittet={this.onSamletResultatSubmittet}
            />
        );
    }

    private getKonkurrenceId(): string {
        return this.state.konkurrence === undefined ? '' : this.state.konkurrence.id;
    }

    private getDelopgaveId(): string {
        return this.state.valgtDelopgaveId === undefined ? '' : this.state.valgtDelopgaveId;
    }

    private getOpgaveId(): string {
        return this.state.valgtOpgaveId === undefined ? '' : this.state.valgtOpgaveId;
    }
}

export default OpgaveBedoemmelseContainer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgaveBedoemmelse/OpgaveBedoemmelseContainer.tsx